define('cnf',['jquery','TweenMax'], function($)
{
    'use strict';
    
    var Cnf={
        $window:$(window),
        $document:$(document),
        $body:$('body'),
        
        isTouch:(true===Modernizr.touch),
        click:'click.fdz',
        mobileBreakpoint:768,
        desktopBreakpoint:1024,
        
        dataFlickityCallback:'data-flickitycallback'
    };
    
    Cnf.$app=Cnf.$body.find('.app');
    Cnf.$header=Cnf.$body.find('.main-header');
    
    Cnf.width=0;
    Cnf.height=0;
    Cnf.isMobile=false;
    Cnf.isDesktop=false;
    Cnf.viewport=null;
    Cnf.loggedIn = Cnf.$body.hasClass('logged-in-true') ? true : false;
    
    return Cnf;
});
